export const colors = {
    green: '#86B393'
}